import { lazy } from 'react';
import { RouteDatum } from '../types';

const CompanyClientDataInputView = lazy(async () => await import('../../../../company-client-data-input-view'));
const CompanyPlatformBlanket = lazy(async () => await import('../../../../blanket/company-platform-form'));

export const clientInputRoutes: RouteDatum[] = [
  { path: 'input/products', optionalParams: ['companyId', 'productSetParams'], element: <CompanyPlatformBlanket /> },
  {
    path: 'input/insights/:companyId',
    optionalParams: ['companyName', 'clientSecret'],
    element: <CompanyClientDataInputView dataType="insights" />,
  },
  {
    path: 'input/targets/:companyId',
    optionalParams: ['companyName', 'clientSecret'],
    element: <CompanyClientDataInputView dataType="targets" />,
  },
];
